<template>
    <div :class="[this.productIsOnSale ? 'price--on-sale price price--listing' : 'price price--listing']">
        <dl class="price__sale" v-show="data.comparePrice && data.comparePrice !== data.price">
            <dt class="price__compare meta">
                <span class="visually-hidden visually-hidden--inline">
                    Regular price
                </span>
            </dt> 
                
            <dd class="price__compare meta">
                <s class="price-item price-item--regular meta">
                    <!-- sale sprice -->
                    {{ data.comparePrice }}
                </s>
            </dd>

            <dt>
                <span class="visually-hidden visually-hidden--inline">
                    Sale price
                </span>
            </dt>
        
            <dd>
                <dt>
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                </dt> 
                <dd>
                    <span class="price-item price-item--sale accent meta">
                        <!-- regular price -->
                        {{ data.price }}
                    </span>
                </dd>
                <dt></dt>
                <dd>
                <span class="price-item price-item--sale accent">
                </span>

                    <span class="price-item price-item--sale" style="color: rgb(109, 155, 167);">{{ data.percentOff }}% OFF</span>
                </dd>
            </dd>
        </dl>

        <dt>
            <span class="visually-hidden visually-hidden--inline">
                Sale price
            </span>
        </dt>
        <dl class="price__regular">
            <dt>
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
            </dt> 
            <dd>
                <span class="price-item price-item--regular meta">
                    <!-- regular price -->
                {{ data.price }}
                </span>
            </dd>
        </dl>

    </div>
</template>
    
  <script>
  
  export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
   
    },
  
    computed: {
        productIsOnSale() {
            if(this.data.price && this.data.comparePrice){
                const strippedPrice = parseFloat(this.data.price.split('$')[1]);
                const strippedComparePrice = parseFloat(this.data.comparePrice.split('$')[1]);
                return strippedComparePrice > strippedPrice;
            }
            return false;
        },
        },
    }
  </script>
  
  <style></style>